module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921094151_T.2cc3556a.jpg";